import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { useLocation } from 'react-router-dom';
import { Container } from '@mui/system';
import CssBaseline from '@mui/material/CssBaseline';
import { WebContext } from '../contextProvider/webContextProvider';

const toolbarStyle = {
  minHeight: '0',
};

const NavBar = (props: any) => {
  const { webContent } = React.useContext(WebContext);
  const location = useLocation();
  const currentLocation = location.pathname;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="static"
        component="nav"
        sx={{
          backgroundColor: '#fff',
          boxShadow: 'none',
          borderBottom: '1px solid #E2E2E2',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar className="p-0" style={toolbarStyle}>
            <React.Fragment>
              <Box sx={{ flexGrow: 1 }}>
                <Box className="lead-frm-logo" mt={1} mb={1}>
                  <img
                    src={webContent?.defaultData?.footerLogo}
                    alt="header logo"
                    style={{height:currentLocation === '/get-information'?'':'40px'}}
                  />
                </Box>
              </Box>
            </React.Fragment>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

export default NavBar;
